import { Popover } from '@opendoor/bricks/complex/Modal';
import { Button, Flex, Heading, Text } from '@opendoor/bricks/core';

import { useOfferContext } from 'sellDirect/OfferContext';
import { useQualificationContext } from 'shared/helpers/QualificationContext';
import { HAS_SEEN_REFRESH_MODAL } from 'sellDirect/routes/lwc/helpers/constants';

interface RepeatExperienceModalProps {
  /** Header language */
  title: string;
  /** Subtext in the modal */
  description: string;
  /** Indicate what page this is coming from i.e. Sell/list-with-certainty/buyer-fall-through-protection */
  source: string;
}

/**
 * Modal that lets a user refresh their offer
 *
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const RepeatExperienceModal: React.FC<RepeatExperienceModalProps> = ({
  title,
  description,
  source,
}) => {
  const { isRefreshErrorModalOpen, offer } = useOfferContext();
  const { isEligibleForLwc } = useQualificationContext();

  const { refreshOffer, loading: refreshLoading, isRefreshingOffer } = useOfferContext();

  const shouldDisableCta = isRefreshingOffer || refreshLoading;
  const handleClick = () => {
    window.localStorage.setItem(HAS_SEEN_REFRESH_MODAL, 'true');
    refreshOffer();
  };

  const isOpen = (isEligibleForLwc && offer?.isExpired) ?? false;

  return (
    <Popover
      aria-label="list-with-certainty-introduction-modal"
      analyticsName={`repeat-experience-modal-from-${source}`}
      isOpen={isOpen && !isRefreshErrorModalOpen}
      onRequestClose={handleClick}
    >
      <Flex
        p={8}
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        width={['100%', null, '512px']}
        height={['100%', null, '325px']}
      >
        <Flex flexDirection="column" alignItems="center" textAlign="center">
          <Flex mb={[11, null, 9]} maxW="374px" flexDirection="column" gridGap="5">
            <Heading size="h2" as="h2">
              {title}
            </Heading>
            <Text fontSize="s1" lineHeight="s1">
              {description}
            </Text>
          </Flex>
          <Button
            analyticsName={`${source}-repeat-experience-modal}`}
            aria-label="Continue to dashboard and close modal"
            onClick={handleClick}
            disabled={shouldDisableCta}
          >
            Continue
          </Button>
        </Flex>
      </Flex>
    </Popover>
  );
};
